"use client";

import { AlertCircleIcon, LayoutDashboardIcon } from "lucide-react";
import { useFeatureFlag } from "@/hooks/use-feature-flag";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavTasks({
  onNavigate,
  activePage,
}: {
  onNavigate: (page: string) => void;
  activePage: string;
}) {
  // let loading = true;

  const priorAuthEnabled = useFeatureFlag("feature_prior_auth");
  const failureManagementEnabled = useFeatureFlag("feature_failure_management");
  const medReconciliationEnabled = useFeatureFlag("feature_med_reconciliation");
  const loading = [
    priorAuthEnabled,
    failureManagementEnabled,
    medReconciliationEnabled,
  ].some((flag) => flag.loading);

  const taskItems = [
    {
      name: "Process Prior Auths",
      id: "prior-auth",
      url: "#",
      icon: LayoutDashboardIcon,
      visualName: "Prior Authorization",
      enabled: priorAuthEnabled.enabled,
    },
    {
      name: "Failure Management",
      id: "failure-management",
      url: "#",
      icon: AlertCircleIcon,
      visualName: "Failure Management",
      enabled: failureManagementEnabled.enabled,
    },
    {
      name: "Medication Reconciliation",
      id: "med-rec",
      url: "#",
      icon: LayoutDashboardIcon,
      visualName: "Medical Reconciliation",
      enabled: medReconciliationEnabled.enabled,
    },
  ].filter((item) => item.enabled); // Only show enabled features

  // Don't render anything while loading to prevent flash
  if (loading) {
    return (
      <SidebarGroup>
        <SidebarGroupLabel>Run your tasks</SidebarGroupLabel>
        <SidebarGroupContent className="py-0.5">
          <SidebarMenu>
            {/* Show loading state or empty state */}
            <div className="text-sm text-muted-foreground px-2 py-1">
              Loading tasks...
            </div>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    );
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Run your tasks</SidebarGroupLabel>
      <SidebarGroupContent className="py-0.5">
        <SidebarMenu>
          {taskItems.map((item) => (
            <SidebarMenuItem key={item.name}>
              <SidebarMenuButton
                asChild
                isActive={activePage === item.id}
                onClick={() => onNavigate(item.id)}
              >
                <a href={item.url} onClick={(e) => e.preventDefault()}>
                  <item.icon />
                  <span>{item.name}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
